import { Button as InternalButton } from './Button';
import { ButtonV2 } from './Button.v2';

import type { ButtonProps } from './Button.types';
import { ButtonV2Component, ButtonV2Props } from './Button.v2.types';

type InternalButtonType = typeof InternalButton;

export type ButtonInterface = InternalButtonType & {
  v2: ButtonV2Component;
};

const Button = InternalButton as ButtonInterface;
Button.v2 = ButtonV2;

export { Button };
export type { ButtonProps, ButtonV2Props };
export default Button;
export * from './Button.types';
export { IconButton } from './IconButton';
export * from './IconButton.types';
export { useButton } from './useButton';
